import { HttpClient } from '@sparkdotfi/common-universal/http-client'
import { Logger } from '@sparkdotfi/common-universal/logger'
import { z } from 'zod'

import { apiUrl } from '@/config/consts'

export interface CloneVnetArgs {
  srcContainerId: string
}

export interface CloneVnetResult {
  rpcUrl: string
}

export async function cloneVnet({ srcContainerId }: CloneVnetArgs): Promise<CloneVnetResult> {
  if (import.meta.env.VITE_DEV_SANDBOX_CLONE_VNET_EXTENSION !== '1') {
    throw new Error('Clone Vnet extension is not enabled')
  }

  const httpClient = new HttpClient({}, Logger.BROWSER)
  const response = await httpClient.post(
    `${apiUrl}/sandbox/clone`,
    {
      src_container_id: srcContainerId,
    },
    cloneVnetResponseSchema,
    {
      authorization: `Bearer ${import.meta.env.VITE_CLONE_VNET_ENDPOINT_SECRET}`,
    },
  )

  return {
    rpcUrl: response.simulation_fork.rpc_url,
  }
}

const cloneVnetResponseSchema = z.object({
  simulation_fork: z.object({
    rpc_url: z.string(),
  }),
})
